import ArtistProfileCard from "@components/Account/Artist/Settings/ArtistProfileCard";
import LBox from "@components/LBox";
import LScreen from "@components/LScreen";
import React from "react";

export const ArtistSettingsScreen = () => {
  return (
    <LScreen enableAutomaticTopPadding={true}>
      <LBox gap="s3">
        <ArtistProfileCard />
      </LBox>
    </LScreen>
  );
};
